// extracted by mini-css-extract-plugin
export var investorCard = "Investors-module--investorCard--tcbIw";
export var investorsGrid = "Investors-module--investorsGrid--NcBUC";
export var investorsSection = "Investors-module--investorsSection--UL0+V";
export var logoWrapper = "Investors-module--logoWrapper--0OGh0";
export var sectionTitle = "Investors-module--sectionTitle--bJb2b";